module.exports = __webpack_public_path__ + "static/media/le-parisien.74e84d2f.png";